import AxiosInstance from './AxiosInstance';

export const getDashboardList = (prms) =>
  AxiosInstance.get(`devotional/dashboard-counts`, {
    params: {
      startDate: prms?.startDate,
      endDate: prms?.endDate,
    },
  });
